export const OFAC_REASONS = ['ofac reject', 'ofac block'];
export const OFAC_DISABLE_REASON = 'Under Sanctions review \u2013 SLOD only';
